function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useNavigation } from "../../..";
import TextButton from "../../buttons/text-button/TextButton";
const NavigationLink = ({
  url,
  text,
  ...rest
}) => {
  const {
    navigate
  } = useNavigation();
  const navigateToUrl = () => navigate(url);
  return /*#__PURE__*/React.createElement(TextButton, _extends({
    onClick: navigateToUrl
  }, rest), text);
};
export default NavigationLink;
NavigationLink.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string
};